import { Popup, Radio, Swiper } from "react-vant"
import level_logo from "@/assets/images/tabbar/level_logo.svg";
import level_bg from "@/assets/images/tabbar/level_bg.png";
import leftImg from "../../assets/images/left.png"
import rightImg from "../../assets/images/right.png"
import isActiveImg from "../../assets/images/selectActive.png"
import tabbarHook from "@/hook/useTabbar.tsx"
import { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { SwiperInstance } from 'react-vant';
import coinImg from "../../assets/images/coin.png"
import setImg from "../../assets/images/tabbar/setting.png"
import ButtonComp from '../../components/common/ButtonComp';
import rules_bg from "../../assets/images/rules/rules_bg.png"
import rules_bg1 from "../../assets/images/rules/rules_bg1.png"
import rules_bg2 from "../../assets/images/rules/rules_bg2.png"
import rules_bg3 from "../../assets/images/rules/rules_bg3.png"
import rules_bg4 from "../../assets/images/rules/rules_bg4.png"
import rules_bg5 from "../../assets/images/rules/rules_bg5.png"
import { INTRODUCTORY_LIST } from "@/constants/common-constants.ts"
import { FormattingTwoNumber, HighlightPercentages } from "../../utils";
import "./index.less"
import { changeShowIntroductory } from "../../store/module/settins";
import { useNavigate } from "react-router-dom";
import { getIntroductory } from '@/api/url.js'
import { v4 as uuidv4 } from 'uuid';
import { useTranslation } from "react-i18next";



const introductoryPage = () => {
    const { t } = useTranslation();
    const [isShowAgain, setShowAgain] = useState(false)
    const list = INTRODUCTORY_LIST()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const swipeRef = useRef<SwiperInstance>(null);
    const [initialSwipe, setInitialSwipe] = useState(0)
    const { tabbarList } = tabbarHook();
    const userInfo = useSelector((state: any) => state.tabbar.userInfo)
    const chooseBg = (key: number) => {
        switch (key % 6) {
            case 0:
                return rules_bg;
            case 1:
                return rules_bg1;
            case 2:
                return rules_bg2;
            case 3:
                return rules_bg3;
            case 4:
                return rules_bg4;
            case 5:
                return rules_bg5;
        }

    }
    return (
        <Popup
            className="introductory-page"
            teleport={document.querySelector("body")}
            visible={true}
            closeOnClickOverlay={false}
            style={{ width: "100%", height: "100%", backgroundColor: "transparent" }}
            onClose={() => { }}>
            <div className='w-full  h-full relative px-4 flex flex-col justify-center'>
                <div className='w-full flex items-center relative'>
                    <div className={`w-7 h-7 mr-2`} onClick={() => {
                        // if (initialSwipe <= 3 && initialSwipe > 0) {
                        //     navigate(tabbarList.filter((el: any) => !el.isHidden)[initialSwipe - 1].path)
                        // }
                        swipeRef.current?.swipePrev();
                    }}>
                        <img className={`${initialSwipe == 0 ? 'hidden' : ''} w-full h-full`} src={leftImg} alt="" />
                    </div>
                    <Swiper ref={swipeRef} className="flex-1 mySwiper h-[380px]" onChange={(i) => {
                        // if (i <= 3) {
                        //     navigate(tabbarList.filter((el: any) => !el.isHidden)[i].path)
                        // }
                        setInitialSwipe(i)
                    }} loop={false} initialSwipe={initialSwipe}

                    >
                        {
                            list.map((item: any) => {
                                return (
                                    <Swiper.Item>
                                        <div style={{ backgroundSize: "100% 100%" }} className="bg-[url(@/assets/images/refining/card_refining_guide.png)] h-[380px] py-[20px] px-[10px] flex flex-col  items-center ">
                                            <div className="font-bold text-[20px] text-[#333] leading-[24px] mb-[12px] text-center">
                                                {item.title}
                                            </div>
                                            <div className="h-[360px]  overflow-y-scroll">

                                                <div className="flex flex-col gap-[10px]">
                                                    {item.text.map((e: any, ind: number) =>
                                                        <div>
                                                            <div key={e.index} style={{ background: !e.isImage ? `url(${chooseBg(ind)})` : '', backgroundSize: "100% 100%" }} className=" p-[10px] pl-[6px] text-[14px] flex justify-center text-[#333] leading-[18px] rounded-[10px]">
                                                                {
                                                                    !e.isImage && <div className="text-[14px]text-[#333] inline leading-[18px]" dangerouslySetInnerHTML={{ __html: HighlightPercentages(e.content) }}></div>

                                                                }
                                                                {
                                                                    e.isImage && <img className="w-[190px] absolute" src={e.image} alt="" />
                                                                }

                                                            </div>

                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                        </div>

                                    </Swiper.Item>
                                )
                            })
                        }
                    </Swiper>
                    <div className="w-7 h-7 ml-2" onClick={() => {

                        if (initialSwipe <= 3) {
                            // navigate(tabbarList.filter((el: any) => !el.isHidden)[initialSwipe + 1].path)
                        }
                        swipeRef.current?.swipeNext();
                    }}>
                        <img className={`${initialSwipe == 5 ? 'hidden' : ''} w-full h-full`} src={rightImg} alt="" />
                    </div>
                </div>

                <div className="btn w-full flex flex-col justify-center mt-[40px]">

                    <div className="flex items-center justify-center" onClick={() => {
                        setShowAgain(!isShowAgain)
                    }}>
                        {
                            !isShowAgain ? <div className="w-4 h-4 rounded-full mr-1"></div>
                                : <img className="w-4 h-4 mr-1" src={isActiveImg} alt="" />
                        }

                        <span className="ml-2 text-white">{t("other.page")}</span>
                    </div>
                    <div className={`${initialSwipe != tabbarList.length - 1 ? 'opacity-0' : ''} mt-4`}>
                        <ButtonComp width={100} title={t("other.ok")} callBack={async () => {
                            if (isShowAgain) {
                                await getIntroductory(true)
                            }
                            dispatch(changeShowIntroductory(false))
                        }}></ButtonComp>
                    </div>

                </div>

                <div className='flex absolute top-0 left-0 w-full h-[44px] z-[100]'>
                    <div className='progress-box w-[calc(100%_-_0px)] h-[44px] justify-between items-center flex z-[100]'>
                        <div className={`${initialSwipe == 5 ? '' : 'hidden'} ml-[52px] z-[100] w-[120px] h-[36px] bg-[#fff] hand_down1 flex justify-center items-center rounded-md`}>

                            <img className="w-[20px] total_1 mr-1 h-[20px]" src={coinImg} alt="" />
                            {userInfo.balance ?
                                <p style={{ right: 0 }} className="textStroke relative text-style-level text-[16px] leading-[19px]" data-content={userInfo.balance.toString() && FormattingTwoNumber(userInfo.balance.toString())}>{userInfo.balance.toString() && FormattingTwoNumber(userInfo.balance.toString())}</p> :
                                <p style={{ right: 0 }} className="textStroke relative text-style-level text-[16px] leading-[19px]" data-content={0}>{0}</p>}
                        </div>
                        <div className={`${initialSwipe == 5 ? '' : 'hidden'}  right-4 w-[36px] h-[36px] bg-[#fff] hand_down1 flex justify-center items-center rounded-md`}>
                            <img src={setImg} alt="" />
                        </div>
                    </div>
                </div>

                <div style={{ boxSizing: 'border-box' }} className='h-[85px] box-border w-full absolute bottom-0 left-0'>
                    <div className="w-full px-2 mt-2 flex justify-around box-border z-50">
                        {
                            tabbarList.filter((item: any) => !item.isHidden).map((item: any, index: number) => {
                                return (

                                    <>

                                        {<div onClick={() => { }} className={`${item.introductoryIdex == 0 ? '' : ''} rounded-[6px] transition-all w-[44px] h-[44px] ${item.introductoryIdex == initialSwipe ? 'bg-[#fff] hand_down' : ''} flex flex-col justify-center items-center text-center relative z-10`} key={item.introductoryIdex}>

                                            {
                                                item.introductoryIdex == initialSwipe && <>
                                                    <div className={`img tabbarIcon w-[30px] h-[30px] flex justify-center items-center rounded `}>
                                                        <img className={`w-[20px] h-[20px]`} src={item.imgUrlActive} alt="" />
                                                    </div>
                                                    <div className="mt-[2px] font-bold text-[14px] leading-[18px] text-transparent bg-clip-text bg-gradient-to-r from-[#00E49F] to-[#54ADFF]">{item.title}</div>
                                                </>
                                            }

                                        </div>
                                        }
                                    </>

                                )
                            })
                        }

                    </div>
                </div>
            </div>

        </Popup>
    )
}


export default introductoryPage